import { Injectable } from "@angular/core";
import { TalosDateInfo } from "../models/dateinfo/talos-date-info";

@Injectable()
export class DateService {
  public days: string[] = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  public monthNames: string[] = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

  public formatDateToStringWithDayOfWeek(date: TalosDateInfo) {
    const utcDate = new Date(date.utc.isO8601);
    return this.days[utcDate.getDay()] + ' ' + utcDate.getDate() + ' ' + this.monthNames[utcDate.getMonth()] + ' ' + utcDate.getFullYear();
  }

  public formatTime(date: TalosDateInfo) {
    const utcDate = new Date(date.utc.isO8601);
    var formatMinutes = (minutes:number) => {
      return minutes < 10 ?
        '0' + minutes :
        minutes.toString();
    };
    return utcDate.getHours() + ':' + formatMinutes(utcDate.getMinutes());
  }
}
